import React from 'react';
import ReactDOM from 'react-dom';
import './Container/index.css';
import App from './Container/App';

import 'tachyons';
import * as serviceWorker from './Container/serviceWorker';
// import robot from './robot';

ReactDOM.render(<App/>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
